<template>
    <span v-if="mostrarBtnFaturarPagamento">
        <b-button variant="success" @click.stop="abrirModalFaturar()">
            <i class="fa fa-file-text-o"></i> Faturar Pagamento
        </b-button>
        <b-modal
            id="modalFaturarPagamentoDespGerais"
            v-model="mostrarModalFaturarPagamento"
            centered
            hide-header
            body-class="text-center px-4 pt-4"
            footer-class="justify-content-center border-0 pb-4"
        >
            <div class="text-warning mb-3">
                <i class="fa fa-exclamation-triangle fa-3x"></i>
            </div>
            <h4 class="mb-3">Faturar Pagamento</h4>
            <b-form-group class="text-left">
                <label for="tipoMovimentoDestino">Tipo de Movimento</label>
                <b-form-select
                    id="tipoMovimentoDestino"
                    v-model="tipoMovimentoDestino"
                    :options="tiposMovimentosOptions"
                    @input="$v.tipoMovimentoDestino.$touch()"
                    :state="$v.tipoMovimentoDestino.$error ? false : null"
                ></b-form-select>
                <b-form-invalid-feedback>
                    Selecione um tipo de movimento
                </b-form-invalid-feedback>
            </b-form-group>
            <div slot="modal-footer">
                <b-button variant="danger" @click.stop="fecharModalFaturar()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="success"
                    :disabled="$v.$invalid"
                    @click.stop="confirmarFaturarPagamento()"
                    class="ml-2"
                >
                    Sim, Faturar
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { pagamentoStatus } from './PagamentoStatus'

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModalFaturarPagamento: false,
            tipoMovimentoDestino: '',
            tiposMovimentosDestino: []
        }
    },

    methods: {
        abrirModalFaturar() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .obterTiposMovimentoDestino(this.pagamento.pagamentoId)
                .then(response => {
                    this.$store.dispatch('removeRequest')
                    this.tiposMovimentosDestino = (response && response.success) ? response.data : []

                    if (this.tiposMovimentosDestino.length === 0) {
                        this.$toast.warning(
                            'Nenhum tipo de movimento destino disponível para as despesas deste pagamento.',
                            'ATENÇÃO',
                            this.$toastConfig.warning
                        )
                        return
                    }

                    this.mostrarModalFaturarPagamento = true
                })
                .catch(() => {
                    this.$store.dispatch('removeRequest')
                    this.$toast.error(
                        'Erro ao obter os tipos de movimento disponíveis para faturamento.',
                        'ERRO',
                        this.$toastConfig.error
                    )
                })
        },

        fecharModalFaturar() {
            this.mostrarModalFaturarPagamento = false
            this.tipoMovimentoDestino = ''
            this.tiposMovimentosDestino = []
            this.$v.$reset()
        },

        confirmarFaturarPagamento() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                return
            }

            this.$store.dispatch('addRequest')

            this.pagamentosServicos
                .faturarPagamento(this.pagamento.pagamentoId, this.tipoMovimentoDestino)
                .then(response => {
                    this.$store.dispatch('removeRequest')

                    if (response && response.success) {
                        this.$toast.success(
                            'Pagamento faturado com sucesso!',
                            'SUCESSO',
                            this.$toastConfig.success
                        )
                        this.fecharModalFaturar()
                        this.$emit('obterPagamentoAtualizado')
                    } else {
                        this.$toast.error(
                            (response && response.errors && response.errors[0]) ||
                                'Não foi possível faturar o pagamento no RM.',
                            'ERRO NO FATURAMENTO',
                            this.$toastConfig.error
                        )
                    }
                })
                .catch(() => {
                    this.$store.dispatch('removeRequest')
                    this.$toast.error(
                        'Erro ao comunicar com o servidor.',
                        'ERRO',
                        this.$toastConfig.error
                    )
                })
        }
    },

    computed: {
        tiposMovimentosOptions() {
            return [
                { value: '', text: 'Selecione um tipo de movimento' },
                ...this.tiposMovimentosDestino.map(cod => ({
                    value: cod,
                    text: cod
                }))
            ]
        },

        mostrarBtnFaturarPagamento() {
            return (
                this.pagamento.status === pagamentoStatus.EM_PROCESSAMENTO_PELO_SETOR_FINANCEIRO &&
                this.$temAcesso('SGTEC-UFI-PAG-04')
            )
        }
    },

    validations: {
        tipoMovimentoDestino: { required }
    }
}
</script>
